import { getProductPayload } from './product'

interface Tracker {
  track: (_eventName: string, _payload?: Record<string, any>) => Promise<void>
}

export default function (tracker: Tracker) {
  return {
    async clickedQuickAdd({ baseSku, sku, location }: { baseSku: string; sku: string; location: string }) {
      await tracker.track('Quick Add - Open Modal', {
        baseSku,
        sku,
        location,
      })
    },

    async addedToCart(customisedProduct: any) {
      await tracker.track('Quick Add - Product Added To Cart', {
        ...getProductPayload(customisedProduct),
      })
    },

    async viewFullProduct(customisedProduct: any) {
      await tracker.track('Quick Add - View Full Product', {
        ...getProductPayload(customisedProduct),
      })
    },

    async closed() {
      await tracker.track('Quick Add - Closed Modal')
    },
  }
}
